export default __webpack_public_path__ + "static/media/install-chat-widget4.1891f2d2.JPG";